import 'antd/dist/antd.min.css';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import App from '~/App';
import GlobalStyles from './components/GobalStyles';
import { UserProvider } from './providers/UserProviders';
import reportWebVitals from './reportWebVitals';
import { store } from './store';
import * as SentryLink from '~/constants/linkSentry';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { ENV } from './config/enviroment';

const getBaseURL = (str = 'production') => {
    if (str === 'production') {
        return SentryLink.SENTRY_PRODUCT;
    } else {
        return SentryLink.SENTRY_DEV;
    }
};

Sentry.init({
    dsn: getBaseURL(ENV),
    integrations: [new BrowserTracing()],
    tracesSampleRate: 0.6,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Provider store={store}>
        <GlobalStyles>
            <UserProvider>
                <App />
            </UserProvider>
        </GlobalStyles>
    </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
